import Download16 from '@carbon/icons-react/es/download/16';
import Grid16 from '@carbon/icons-react/es/grid/16';
import List16 from '@carbon/icons-react/es/list/16';
import { Tabs as AntTabs } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { AttachmentsAPI } from 'api/attachments';
import { IconShell } from 'components/atoms/icon-shell';
import { DownloadLink } from 'components/molecules/download-link/download-link';
import { ButtonWrapper } from 'components/molecules/views/components';
import { AttachmentsTabViews } from './types';

const { TabPane } = AntTabs;

const Tabs = styled(AntTabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
    /* to override parent's styling */
    position: static !important;
    z-index: 1 !important;
    background-color: transparent !important;

    &::before {
      border-bottom: none;
    }
  }

  .ant-tabs-ink-bar-animated {
    display: none;
  }

  .ant-tabs-tab {
    padding: 0;
    min-width: auto;
    border-bottom: none;
  }
`;

const StyledButtonWrapper = styled(ButtonWrapper)`
  margin-left: var(--spacing-03);
  &:hover svg,
  &:focus svg {
    color: var(--gray-100);
  }
`;

export const TaskAttachmentsTabs: FC<{
  onChooseTab(tab: AttachmentsTabViews): void;
  taskId?: number;
  projectId?: number;
}> = ({ onChooseTab, taskId, projectId }) => {
  const handleTabChange = (_activeTab) => {
    onChooseTab(_activeTab);
  };

  const handleTabClick = (
    key: string,
    e: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
  ) => {
    e.stopPropagation();
  };

  return (
    <Tabs
      defaultActiveKey={AttachmentsTabViews.GridView}
      onTabClick={handleTabClick}
      onChange={handleTabChange}
    >
      <TabPane
        key={AttachmentsTabViews.GridView}
        tab={
          <span data-cy="attachments.grid_view_trigger">
            <IconShell size="small" icon={<Grid16 />} />
          </span>
        }
      />
      <TabPane
        key={AttachmentsTabViews.TableView}
        tab={
          <span data-cy="attachments.list_view_trigger">
            <IconShell size="small" icon={<List16 />} />
          </span>
        }
      />
      {projectId !== undefined && taskId !== undefined ? (
        <TabPane
          key=""
          tab={
            <span data-cy="attachments.download_all_trigger">
              <DownloadLink
                url={AttachmentsAPI.getDownloadLinkForAttachmentsInTask(
                  projectId,
                  taskId,
                )}
              >
                <StyledButtonWrapper>
                  <Download16 />
                </StyledButtonWrapper>
              </DownloadLink>
            </span>
          }
        />
      ) : null}
    </Tabs>
  );
};
